<template>
    <div>
        <!-- 生产控制台 -->
        <order-search
                :count-data="countTagData"
                :search-url="searchUrl"
                :handle-success="handleSearchResponse"
                :refresh-url="noFinishUrl"
                :handle-re-fresh="initOrderResponse"
        >
            <el-col :span="1">
                <i v-show="loading" class="el-icon-loading"></i>
            </el-col>
            <el-col :span="2">
                <el-tag type="info" size="small">订单数量:{{ orderLength }} / {{ count }}</el-tag>
            </el-col>

        </order-search>
        <order-table @handlesort="setOrderResponse" :sort-url="noFinishUrl" :orders="orders"></order-table>
        <next-foo
                :handle-response="handleNext"
                :no-more="noMore"
                :next-url="nextUrl">
        </next-foo>
    </div>


</template>

<script>
    import OrderSearch from "../components/orders/OrderSearch"
    import OrderTable from "../components/orders/OrderTable"
    import NextFoo from "../components/NextFoo"
    import {mapGetters} from 'vuex'

    export default {
        name: "OrderPro",
        data() {
            const rootUrl = `${this.$const.orderListUrl}?produceinfo__isnull=false`

            return {
                count: 0,
                nextUrl: '',
                loading: false,

                // 所有的生产订单
                searchUrl: rootUrl,

                // 未完成的生产订单
                noFinishUrl: `${rootUrl}&produceinfo__finish=false`,

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}produce_counts/`,
                    dataArr: [
                        {
                            tagName: '已完成: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&produceinfo__finish=true`,
                            countKey: 'finished',
                            type: 'success'
                        },
                        {
                            tagName: '待处理: ',
                            count: 0,
                            loading: false,
                            url:  `${rootUrl}&produceinfo__finish=false`,
                            countKey: 'un_finish',
                            type: 'danger'
                        },
                        {
                            tagName: '加急: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&produceinfo__finish=false&urgent=true`,
                            countKey: 'urgent',
                            type: 'danger'
                        },
                    ],
                },
            }
        },
        computed: {
            noMore() {
                return !Boolean(this.nextUrl)
            },
            orders() {
                return this.produceOrderData['orderList']
            },
            orderLength() {
                return this.orders.length
            },
            ...mapGetters([
                'produceOrderData',
            ])
        },
        methods: {

            initOrders() {
                if (this.orderLength <= 0) {
                    this.loading = true
                    this.$getRequest(this.noFinishUrl)
                        .then(response => {
                            this.loading = false
                            this.initOrderResponse(response)
                        })
                        .catch(error => {
                            this.loading = false
                        })
                }
            },
            handleNext(response) {
                this.addOrderResponse(response)
            },
            initOrderResponse(response) {
                this.setOrderResponse(response)
            },

            handleSearchResponse(searchResponse) {
                this.setOrderResponse(searchResponse)

            },

            setOrderResponse(response) {
                const mutation = 'setProduceOrders'
                this._handleOrderResponse(response, mutation)
            },

            addOrderResponse(response) {
                const mutation = 'addProduceOrders'
                this._handleOrderResponse(response, mutation)
            },

            _handleOrderResponse(response, mutation = 'addProduceOrders') {
                this.count = response.data.count
                this.nextUrl = this.$utils.handleOrderUrl(response.data.next)
                this.$store.commit(mutation, response.data.results)
            },
        },
        components: {NextFoo, OrderSearch, OrderTable},
        created() {
            this.initOrders()
        }
    }
</script>

<style scoped>
</style>